import React, { useMemo } from "react";
import { Input, SelectPicker, Schema, Button, Tooltip } from "rsuite";
import { Link } from "react-router-dom";
import styled from "styled-components";

import TableEditCellsNew from "components/Table/TableEditCells/TableEditCellsNew";
import { BaseButton } from "components/base/BaseButton";
import { Icon } from "components/Icon";

import Whisper from "components/Whisper";

const { StringType } = Schema.Types;

const formModelLogin = Schema.Model({
    login: StringType()
        .isRequired("Required")
});

const formModelTelegram = Schema.Model({
    telegram_username: StringType()
        .isRequired("Required")
        .pattern(/.*\B@(?=\w{5,32}\b)[a-zA-Z0-9]+(?:_[a-zA-Z0-9]+)*.*/, "Telegram username must be 5–32 characters long and start with \"@\"."),
});

const formModelEmail = Schema.Model({
    email: StringType()
        .isRequired("Required")
});

const formModelRoleList = Schema.Model({
    role_list: StringType()
        .isRequired("Required")
});


export default (
    {
        data,
        adminRoleList,
        getManagerAccountUser,
        setActiveUserId,
        setShowModalRemove,
        setShowModalCreate,
        ...props
    }
) => {
    const columns = useMemo(() => [
        {
            name: "Login",
            dataKey: "login",
            flexGrow: 2,
            title: true,

            accepter: Input,
            placeholder: "Login",
            model: formModelLogin,
        },
        {
            name: "Name",
            dataKey: "name",
            value: ({ name, surname }) => `${name}${surname ? " " + surname : ""}`,
            flexGrow: 2,
            title: true,

            accepter: Input,
            placeholder: "Name",
            model: formModelLogin,
        },
        {
            name: "Telegram",
            dataKey: "telegram_username",
            flexGrow: 1,
            title: true,


            accepter: Input,
            placeholder: "Telegram",
            model: formModelTelegram,

            value: ({ telegram_id_ready, telegram_username }) => {
                return <>
                    <span>{telegram_username}</span>
                    {telegram_id_ready ? <Whisper
                        trigger="hover"
                        speaker={<Tooltip>Subscribed</Tooltip>}
                    >
                        <ReadyIcon icon="check-circle-o"></ReadyIcon>
                    </Whisper> : null}
                </>;
            }
        },
        {
            name: "Email",
            dataKey: "email",
            flexGrow: 2,
            title: true,

            accepter: Input,
            placeholder: "Email",
            model: formModelEmail,
        },
        {
            name: "Role list",
            dataKey: "role_list",
            value: ({ role_list }) => role_list.join(", "),
            flexGrow: 2,
            title: true,

            accepter: SelectPicker,
            placeholder: "Role list",
            model: formModelRoleList,
            defaultValue: ({ role_list }) => role_list[0],

            searchable: false,
            cleanable: false,
            data: adminRoleList
                ? adminRoleList.map(x => ({ value: x, label: x }))
                : [],
        },
        {
            name: "",
            dataKey: "actions",
            width: 120,
            value: (rowData) => {
                return (
                    <div className="tableFilters_buttons">
                        <BaseButton
                            size="sm"
                            buttonStyle="primary"
                            tooltipText={<>Login as <b>{rowData.name}</b></>}
                            tooltipPlacement="leftStart"
                            componentClass={Link}
                            to={`/redirect?user-id=${rowData.id}`}
                        >
                            <Icon style={{ fontSize: 14 }} icon="sign-in" />
                        </BaseButton>
                        <Button
                            size="sm"
                            color="lightblue"
                            onClick={() => {
                                setActiveUserId(rowData.id);
                                setShowModalCreate(true);
                            }}
                        >
                            <Icon icon="edit2" />
                        </Button>
                        <Button
                            size="sm"
                            color="red"
                            onClick={() => {
                                setActiveUserId(rowData.id);
                                setShowModalRemove(true);
                            }}
                        >
                            <Icon icon="trash2" />
                        </Button>
                    </div>
                )
            }
        }
    ], [adminRoleList, setActiveUserId, setShowModalCreate, setShowModalRemove]);

    return (
        <StyledTableWrapper>
            <TableEditCellsNew
                data={data}
                columns={columns}
                height={700}

                autoHeight={false}
                editable={false}
                showFormCreate={false}
                rowClassName={(rowData) => rowData && !rowData.active ? "disabled" : ""}
                {...props}
            />
        </StyledTableWrapper>
    );
};

const StyledTableWrapper = styled.div`
    .tableFilters_buttons .rs-btn {
        border-radius: 6px;
    }

    .rs-table-row.disabled:after {
        content: "";
        position: absolute;
        opacity: 0.2;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #4c4c59;
        pointer-events: none;
    }
`;

const ReadyIcon = styled(Icon)`
    && {
        position: absolute;
        margin-top: 3px;
        right: 10px;
        color: var(--color-success);
    }
`;
